import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.dashboard.admindashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-dashboard-admindashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.dashboard.admindashboard/view.scss */
/* src/app/portal.dashboard.admindashboard/view.scss: no such file or directory */`],
})
export class PortalDashboardAdmindashboardComponent implements OnInit {
    

    // Dataset
    public datasetList: any[] = [];
    public datasetFiltered: any[] = [];
    public selectedDatasetId: string | null = null;
    public selectedDatasetInfo: any = null;
    public datasetSearch = '';

    // QA Dataset
    public qaList: any[] = [];
    public qaFiltered: any[] = [];
    public selectedQAId: string | null = null;
    public selectedQAInfo: any = null;

    // User summary
    public userSummary: {
        total: number;
        admin: number;
        normal: number;
    } | null = null;

    constructor(@Inject( Service) public service: Service) {}

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();
        await this.loadDatasetList();
        await this.loadQAList(); 
        await this.loadUserSummary(); 
        await this.service.render();
    }

    async loadDatasetList() {
        try {
            const res = await wiz.call("browse_summary");
            const items = res?.data?.items ?? [];

            this.datasetList = items;
            this.datasetFiltered = [...items];

            // ✅ 처음엔 "전체"로
            this.selectedDatasetId = '';
            await this.onSelectDataset();
        } catch (e) {
            this.datasetList = [];
            this.datasetFiltered = [];
            this.selectedDatasetId = '';
            this.selectedDatasetInfo = null;
        }

        await this.service.render();
    }


    async filterDataset() {
        const q = this.datasetSearch.toLowerCase().trim();

        this.datasetFiltered = this.datasetList.filter(ds =>
            ds.name.toLowerCase().includes(q)

        );
        await this.service.render();
    }


    async onSelectDataset() {
        // ✅ 빈 값이면 전체 요약
        if (!this.selectedDatasetId) {
            const res = await wiz.call('dataset_summary_all');
            this.selectedDatasetInfo = res?.data ?? null;
            await this.service.render();
            return;
        }

        const res = await wiz.call(`dataset_summary?id=${this.selectedDatasetId}`);
        this.selectedDatasetInfo = res?.data ?? null;
        await this.service.render();
    }


    async loadQAList() {
        const res = await wiz.call('get_qa_group_list');

        const items =
            res?.data?.data?.items ??
            res?.data?.items ??
            [];

        this.qaList = items;
        this.qaFiltered = [...items];

        // ✅ 처음엔 "전체"로
        this.selectedQAId = '';
        await this.onSelectQA();

        await this.service.render();
    }


    async onSelectQA() {
        // ✅ 빈 값이면 전체 요약
        if (!this.selectedQAId) {
            const res = await wiz.call('get_qa_group_summary_all');
            const data = res?.data?.data ?? res?.data ?? null;

            this.selectedQAInfo = {
                ...data,
                assigned_users: data?.assigned_users ?? []
            };
            await this.service.render();
            return;
        }

        const res = await wiz.call('get_qa_group_summary', {
            group_id: this.selectedQAId
        });

        const data = res?.data?.data ?? res?.data ?? null;

        this.selectedQAInfo = {
            ...data,
            assigned_users: data?.assigned_users ?? []
        };
        await this.service.render();
    }

    async loadUserSummary() {
        const res = await wiz.call('get_user_summary');
        this.userSummary = res?.data?.data ?? null;
        await this.service.render(); 
    }

    public getPercent(v: any, total: any) {
        if (!v || !total) return 0;
        const p = Math.floor((v / total) * 100);
        return p > 100 ? 100 : p;
    }

}

export default PortalDashboardAdmindashboardComponent;